const getPageOffsets = () => {
    const scrollPosX = window.pageXOffset || window.scrollX || document.documentElement.scrollLeft;
    const scrollPosY = window.pageYOffset || window.scrollY || document.documentElement.scrollTop;
    return [scrollPosX, scrollPosY];
};

const getOffset = (el) => {
    const boundingRect = el.getBoundingClientRect();
    const pageOffsets = getPageOffsets();
    return [boundingRect.left + pageOffsets[0], boundingRect.top + pageOffsets[1]];
};

const getScrollPos = (scrollNode) => {
    const isWindow = scrollNode && scrollNode.document && scrollNode.location && scrollNode.alert && scrollNode.setInterval;

    if (scrollNode && !isWindow) {
        return [scrollNode.scrollLeft, scrollNode.scrollTop];
    }
    return getPageOffsets();
};

export {getOffset, getScrollPos};
